module.exports = __webpack_public_path__ + "static/media/author-image-7you.87176bf2.jpg";